import * as React from "react";
import EditItems from "./parteEmpresas/EditItems";
import EditPopUpAdmin from "./parteEmpresas/EditPopUpAdmin";
import { connect, useDispatch, useSelector } from "react-redux";

import { hosting, mapStateToProps } from "../models/buscar";
import axios from "axios";
import { CLIENTES_REDUX } from "../../../redux/constanst";

function EditUser(props) {
  const { actualizarLista } = useSelector((state) => state.userState);
  const [empresa, setEmpresa] = React.useState([]);
  const dispatch = useDispatch();
  React.useEffect(() => {
    axios
      .get(`${hosting}/mimegacall/api/select_usuarios.php`)
      .then((response) => {
        const arr = Object.values(response.data);
        setEmpresa(arr);
        dispatch({ type: CLIENTES_REDUX, clientesRedux: arr });
      })
      .catch(function (error) {
        console.log(error);
      });
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualizarLista]);

  const Empresas = [
    {
      item: 0,
      name: "Clientes",
      lista: empresa,
    },
  ];

  return (
    <div>
      {Empresas.map((solicitud) => {
        return (
          <>
            <EditPopUpAdmin
            
              btnLabel={
                solicitud.name === "Clientes"
                  ? "Crear empresa"
                  : "Agregar un anexo nuevo"
              }
              datos={{}}
            />
            <EditItems rows={solicitud.lista} type={solicitud.name} id={solicitud.id} />
          </>
        );
      })}
    </div>
  );
}

export default connect(mapStateToProps, null)(EditUser);
